export default __webpack_public_path__ + "static/media/decorativa5.c1715521.jpg";